const moment = require("moment");

if (!Array.prototype.flat) {
  Array.prototype.flat = function (depth) {
    if (depth === undefined) depth = 1; //默认展开一级
    var arr = [];
    function digui(dst, srcArr, depth) {
      for (var i = 0; i < srcArr.length; i++) {
        var val = srcArr[i];
        if (Array.isArray(val)) {
          if (depth > 0) digui(dst, val, depth - 1);
          else dst.push(val);
        } else dst.push(val);
      }
    }
    digui(arr, this, depth);
    return arr;
  };
}


new function () {

  Object.Extend = extend
  function extend() {
    var extended = {};
    // 将对象属性合并到已存在的对象中
    var merge = function (obj) {

      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // 如果属性为对象并且需要深拷贝时则使用函数递归、反之则将当前的属性替换现有的属性
          if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
            extended[prop] = extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };
    // 遍历所有对象属性
    for (var i = 0; i < arguments.length; i++) {
      merge(arguments[i]);
    }
    return extended;
  }


}()

//TODO 修改为原型
function defineClassMethod(constructor, name, method) {
  return Object.defineProperty(constructor.prototype, name, {
    value: method,
    writable: false,   // 决定了属性是否可被赋值更改
    enumerable: false, // 决定了属性在for in循环中是否会被遍历到
    configuable: false // 决定了属性是否能被delete语句删除
  });
}


Array.prototype.Unique = function () {
  var arr = this;
  return [...new Set(arr)];
};

Array.prototype.Distinct = function (groupFn, fn2) {
  if (!groupFn) return this.Unique();

  //开始分组
  let group = {};
  this.forEach((p) => {
    let groupKey = groupFn(p);
    let item = p;
    let arr = group[groupKey];
    if (!arr) {
      group[groupKey] = [item];
    } else {
      arr.push(item);
    }
  });
  //开始抽取
  let newArr = [];
  for (const key in group) {
    const children = group[key];
    let val = fn2 ? fn2(key, children) : children[0];
    newArr.push(val);
  }
  return newArr;
};

Array.prototype.RemoveAll = function (func) {
  var arr = this;
  var len = arr.length;
  if (func == undefined) {
    return;
  }
  for (var i = 0; i < len; i++) {
    var entity = arr[i];
    var result = false;
    if (func && func(entity) === true) {
      arr.splice(i, 1);
      len--;
      i--;
    }
  }
};

Date.prototype.toJSON = function () {
  return moment(this).format("YYYY-MM-DD HH:mm:ss");
};


let _MyList2Tree = function (mylist, Field, ParentField, func) {
  let ids = []
  for (const item of mylist) {
    ids.push(item[Field])
  }

  let rootIds = []
  for (const item of mylist) {
    if (!item[ParentField] || !ids.includes(item[ParentField])) {
      rootIds.push(item[Field])
    }
  }

  let ret = make(mylist, null, 0)

  return ret
  function make(list, parentId, depth) {
    let arr = []
    list.forEach((element) => {
      let _ParentID = element[ParentField]
      let _CurID = element[Field]
      // console.log(_ParentID,'------PGID-----')
      if ((parentId == null && rootIds.includes(_CurID)) || _ParentID == parentId) {
        // console.log(_CurID,'------GID-----')
        //找出自己的子级
        let children = list.filter((p) => p[ParentField] == _CurID)
        let sublist
        if (children.length > 0) {
          sublist = make(list, _CurID, depth + 1)
        }
        let item = func(element, sublist, depth)
        if (item) arr.push(item)
      }
    })
    return arr
  }
}



Array.prototype.List2Tree = function (Field, ParentField, func) {
  return _MyList2Tree(this, Field, ParentField, func)
};

Array.prototype.Tree2List = function (ChildrenName, func) {
  let id = 0;
  let treeArr = this;
  let newArr = [];
  change(treeArr, null);
  return newArr;

  function change(arr, ParentId) {
    arr.forEach((el, index) => {
      let newId = ++id;
      let newItem = func(newId, ParentId, el);
      newArr.push(newItem);
      let subArr = el[ChildrenName];
      if (subArr && Array.isArray(subArr)) change(subArr, newId);
    });
  }
};

// Array.prototype.Tree2List2 = function (ChildrenName, func) {
//   let id = 0;
//   let treeArr = this;
//   let newArr = [];
//   change(treeArr, null, 1);
//   return newArr;
//   function change(arr, ParentId, depth) {
//     arr.forEach((el, index) => {
//       let depthid = depth;
//       let newId = ++id;
//       let newItem = func(newId, ParentId, el, depthid);
//       newArr.push(newItem);
//       let subArr = el[ChildrenName];
//       if (subArr && Array.isArray(subArr)) {
//         depthid++;
//         change(subArr, newId, depthid);
//       }
//     });
//   }
// };

Array.prototype.GroupBy = function (groupFn, formatFn) {
  let group = {};
  this.forEach((p) => {
    let groupKey = groupFn(p);
    let item = formatFn ? formatFn(p) : p;
    let arr = group[groupKey];
    if (!arr) {
      group[groupKey] = [item];
    } else {
      arr.push(item);
    }
  });

  return group;
};

Array.prototype.ToDict = function (fn1, fn2) {
  let arr = this;
  let dict = {};
  if (!fn1) return dict;
  for (const item of arr) {
    let key = fn1(item);
    dict[key] = fn2 ? fn2(item) : item;
  }
  return dict;
};

Array.prototype.Sum = function (fn) {
  let s = 0;
  if (fn) {
    this.forEach((val) => {
      s += fn(val);
    });
  } else
    this.forEach((val) => {
      s += val;
    });

  return s;
};

// Array.prototype.filterArr = function (name) {
//   let hash = {};
//   return this.reduce((ss, item) => {
//     hash[item[name]] ? '' : hash[item[name]] = true && ss.push(item);
//     return ss;
//   }, []);
// }
